export const handler = (el, e) => {
  el.style.pointerEvents = 'none';
};
